import { AlertDialog } from "client/Components";
import { useDataInputDialog } from "client/Hooks";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement, useCallback } from "react";

export type UnableToOpenDocumentLocationDialogProps = {
	onClose: () => void;
};

export const UnableToOpenDocumentLocationDialog = (props: UnableToOpenDocumentLocationDialogProps): ReactElement => {
	const {
		onClose
	} = props;

	return (
		<AlertDialog
			trackingId="unable-to-open-location-dialog"
			title={localize("_UnableToOpenFolder")}
			confirmText={localize("_BackToDocuments")}
			onClose={onClose}
			showCloseButton={false}
		>
			{localize("_ThisFolderCanNotBeOpened")}
		</AlertDialog>
	);
};
UnableToOpenDocumentLocationDialog.displayName = "UnableToOpenDocumentLocationDialog";

export function useUnableToOpenDocumentLocationDialog(): [
	element: ReactElement | null,
	open: () => Promise<void>
] {
	const [element, originalOpen] = useDataInputDialog<{}, void>(
		(_, onClose) => (
			<UnableToOpenDocumentLocationDialog onClose={onClose} />
		)
	);

	const open = useCallback(
		async (): Promise<void> => {
			await originalOpen({});
		},
		[originalOpen]
	);

	return [element, open];
}
